import { Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import LinkButton from 'components/buttons/LinkButton/LinkButton';
import { getText } from 'utils/stringUtil';
import {
  PRIMARY_SUBSCRIBERS_MESSAGE,
  FOR_ADDITIONAL_QUESTIONS,
  SUPPORT_EMAIL,
  BACK,
} from 'constants/languageConstants';

import { setAuthView } from 'modules/auth/slices/employeeAuthSlice';
import { AUTH_VIEW } from 'modules/auth/constants/authConstants';

import styles from './fallback.module.less';
const FallBack = () => {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.benguide.data?.language);
  return (
    <Row justify="center">
      <div>
        <div className={styles.codeWrapper}>
          <h1 className={styles.textWrapper}>
            {getText(PRIMARY_SUBSCRIBERS_MESSAGE, language)}
          </h1>
          <h1 className={styles.textWrapper}>
            {getText(FOR_ADDITIONAL_QUESTIONS, language)}
            <LinkButton
              className={styles.linkBtn}
              href="mailto: support@planyear.com"
            >
              {getText(SUPPORT_EMAIL, language)}
            </LinkButton>
          </h1>
        </div>
        <SubmitButton
          type="primary"
          htmlType="button"
          className={styles.submitPwdButton}
          onClick={() => dispatch(setAuthView(AUTH_VIEW.LOGIN.type))}
        >
          {getText(BACK, language)}
        </SubmitButton>
      </div>
    </Row>
  );
};

export default FallBack;
